// Report's state. Shared between forms

import { createContext, useState } from 'react';

/**
 * Initial default state.
 * Required to avoid null refs errors and ensure an object schema/struct.
 */
const DefaultValues = {
    consumptions: [],
    employees: [],
    photos: [],
    vehicles: [],
    trailers: [],
    extras: [],
    work_id: 0,
    uid: 0,
};

/**
 * Helper function to force full copy of an object since object spreading
 * do not change internal references.
 * This is usefull for reseting the context state to a known/initial empty state.
 * 
 * @param {object} obj 
 * @returns 
 */
const doFreshCopy = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};

export const ReportFormContext = createContext(doFreshCopy(DefaultValues));

export const ReportFormProvider = ({ children }) => {
    const [report, setReport] = useState(doFreshCopy(DefaultValues));

    const resetReport = () => {
        console.log('Resetting report state to', doFreshCopy(DefaultValues));
        setReport(doFreshCopy(DefaultValues));
    };

    return (
        <ReportFormContext.Provider value={{ report, setReport, resetReport }}>
            {children}
        </ReportFormContext.Provider>
    );
};